import React from 'react';
import { TableRow, TableCell, Box, Typography, Chip, Avatar } from '@mui/material';
import { colors, fonts, spacing, tableStyles } from '../../constants';
import { getUserInitials, getStatusColor, getRoleColor, formatUserRole, formatUserRegion } from '../../utils/userUtils';
import { formatDateTime } from '../../utils/dateUtils';
import { REGIONS } from '../../constants/usersPage';

/**
 * UserTableRow Component
 * Individual user row in table
 */
const UserTableRow = ({ user }) => {
  const statusLabel = user.isActive ? 'Active' : 'Inactive';
  const roleLabel = formatUserRole(user.role);
  const createdDate = formatDateTime(user.createdAt);
  const regionLabel = formatUserRegion(user.region, REGIONS);

  return (
    <TableRow 
      key={user._id} 
      hover 
      sx={{ 
        backgroundColor: colors.backgroundWhite,
        '&:hover': { 
          backgroundColor: colors.primaryTint,
          borderLeft: `3px solid ${colors.primaryDark}`,
        },
        '&:nth-of-type(even)': {
          backgroundColor: colors.backgroundLight,
        },
      }}
    >
      <TableCell sx={{ ...tableStyles.cell, color: colors.textPrimary }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: spacing.xs }}>
          <Avatar
            sx={{
              width: 32,
              height: 32,
              background: colors.primaryGradient,
              fontSize: fonts.fontSizeXs,
              fontWeight: fonts.weightSemiBold,
            }}
          >
            {getUserInitials(user.name)}
          </Avatar>
          <Typography sx={{ fontSize: fonts.fontSizeXs, fontWeight: fonts.weightMedium, color: colors.textPrimary }}>
            {user.name}
          </Typography>
        </Box>
      </TableCell>
      <TableCell sx={{ ...tableStyles.cell, color: colors.textPrimary }}>{user.email}</TableCell>
      <TableCell sx={{ ...tableStyles.cell, color: colors.textPrimary }}>
        <Chip
          label={roleLabel}
          size="small"
          sx={{
            backgroundColor: getRoleColor(roleLabel) + '20',
            color: getRoleColor(roleLabel),
            fontWeight: fonts.weightSemiBold,
            fontSize: fonts.fontSizeXs,
          }}
        />
      </TableCell>
      <TableCell sx={{ ...tableStyles.cell, color: colors.textPrimary }}>{regionLabel}</TableCell>
      <TableCell sx={{ ...tableStyles.cell, color: colors.textPrimary }}>
        <Chip
          label={statusLabel}
          size="small"
          sx={{
            backgroundColor: getStatusColor(statusLabel) + '20',
            color: getStatusColor(statusLabel),
            fontWeight: fonts.weightSemiBold,
            fontSize: fonts.fontSizeXs,
          }}
        />
      </TableCell>
      <TableCell sx={{ ...tableStyles.cell, color: '#64748b' }}>{createdDate}</TableCell>
    </TableRow>
  );
};

export default UserTableRow;

